/**
 * Campaign Router - Main navigation component for campaign management
 * Entry point that replaces individual campaign components in your app
 */

import React, { useState } from 'react';
import { CampaignManagementHub } from './CampaignManagementHub';
import { EmergencyHelpButton } from '../emma/EmergencyHelpButton';
import { EmmaChat } from '../emma/EmmaChat';

interface CampaignRouterProps {
  // Optional props for future integration
  userId?: string;
  organizationId?: string;
  onNavigate?: (route: string) => void;
}

export const CampaignRouter: React.FC<CampaignRouterProps> = ({
  userId,
  organizationId,
  onNavigate
}) => {
  // This component serves as the main entry point for campaign management
  // The CampaignManagementHub now handles its own data fetching from the backend API
  const [showEmmaHelp, setShowEmmaHelp] = useState(false);

  const handleEmmaHelp = () => {
    setShowEmmaHelp(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <CampaignManagementHub />
      </div>
      
      {/* EPIC CITE-RECOVERY-001: Emma escape hatch */}
      <div className="fixed bottom-6 right-6 z-50">
        <EmergencyHelpButton 
          onClick={handleEmmaHelp}
          isVisible={!showEmmaHelp}
        />
      </div>
      
      {/* Emma Chat Modal */}
      {showEmmaHelp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl h-3/4 flex flex-col">
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-xl font-semibold text-gray-900">Emma - Your Campaign Assistant</h2>
              <button
                onClick={() => setShowEmmaHelp(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <div className="flex-1 overflow-hidden">
              <EmmaChat 
                initialContext={{
                  currentPage: 'campaign-router',
                  userId: userId,
                  organizationId: organizationId
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignRouter;

// Export all related components for flexible integration
export { CampaignManagementHub } from './CampaignManagementHub';
// REMOVED (6C-4 Feb 7): CampaignSetupWizard deprecated - use WorkflowPage.tsx
export { CampaignWorkflowDashboard } from './CampaignWorkflowDashboard';
export { AgentOrchestrationPanel } from './AgentOrchestrationPanel';
